import React from 'react';
import ConfirmationScreen from '../../../Layout/ConfirmationScreen';

export default [
  {
    path: '/confirmationScreen',
    render: (props) => <ConfirmationScreen type="EmployeeRegistration" {...props} />,
  },
];
